import { render, staticRenderFns } from "./EditOilTypeModal.vue?vue&type=template&id=0271cbfc&scoped=true&"
import script from "./EditOilTypeModal.vue?vue&type=script&lang=js&"
export * from "./EditOilTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./EditOilTypeModal.vue?vue&type=style&index=0&id=0271cbfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0271cbfc",
  null
  
)

export default component.exports